import { connect } from "react-redux";
import React from "react";
import { StyleRoot } from "radium";
import settings from "rizzo-next/sass/settings.json";
import Login from "@lonelyplanet/dotcom-core/dist/components/login";
import Toast from "@lonelyplanet/dotcom-core/dist/components/toast/globalToastFromCookie";
import layoutMobile from "./shared/actions/layoutMobile";
import fetchUser from "./shared/actions/fetchUser";
import { connected as UniversalDataTag } from "./shared/components/universalDataTag";
import actions from "./pois/actions";

/**
 * Renders a list of pois
 */
export default class AppComponent extends React.Component {
  constructor() {
    super();

    this.handleLayoutChange = this.handleLayoutChange.bind(this);
  }

  componentDidMount() {
    this.mql = window.matchMedia(`(max-width: ${settings.media.max["768"]})`);

    this.mql.addListener(this.handleLayoutChange);

    this.props.dispatch(layoutMobile(this.mql.matches));
    this.props.dispatch(fetchUser());
  }

  componentWillReceiveProps(nextProps) {
    const { user } = nextProps;
    const shouldFetchBookmarkLists = nextProps.user && !this.props.user && user.id;

    if (shouldFetchBookmarkLists) {
      this.props.dispatch(actions.fetchBookmarkLists({ userId: user.id }));
    }
  }

  componentDidUpdate() {
    if (this.props.udo.content_group_2 === "lists") {
      $("#footer-wrapper").hide();
    } else {
      $("#footer-wrapper").show();
    }
  }

  componentWillUnmount() {
    this.mql.removeListener(this.handleLayoutChange);
  }

  handleLayoutChange() {
    this.props.dispatch(layoutMobile(this.mql.matches));
  }

  render() {
    const { userAgent } = this.props;

    return (
      <StyleRoot radiumConfig={{ userAgent }}>
        {this.props.children}
        <Login />
        <UniversalDataTag
          location={this.props.location}
        />
        <Toast />
      </StyleRoot>
    );
  }
}

AppComponent.propTypes = {
  userAgent: React.PropTypes.string,
  children: React.PropTypes.node,
  dispatch: React.PropTypes.func,
  location: React.PropTypes.objectOf(Object),
  udo: React.PropTypes.object,
  user: React.PropTypes.object,
};

const mapStateToProps = (state) => ({
  userAgent: state.userAgent,
  udo: state.udo,
  user: state.user,
});

const connected = connect(mapStateToProps)(AppComponent);
export { connected };



// WEBPACK FOOTER //
// ./assets/app.jsx